// Secure storage service for sensitive data
export interface StorageKeys {
  CUSTOMER_ID: 'customerID';
  SESSION_ID: 'sessionID';
}

export const STORAGE_KEYS: StorageKeys = {
  CUSTOMER_ID: 'customerID',
  SESSION_ID: 'sessionID',
} as const;

class SecureStorage {
  private storage: Storage;

  constructor(useSessionStorage = false) {
    // Use sessionStorage for better security (cleared on tab close)
    // Use localStorage only for non-sensitive data that should persist
    this.storage = useSessionStorage ? sessionStorage : localStorage;
  }

  setItem(key: string, value: string): void {
    try {
      this.storage.setItem(key, value);
    } catch (error) {
      console.error('Failed to set storage item:', error);
    }
  }

  getItem(key: string): string | null {
    try {
      return this.storage.getItem(key);
    } catch (error) {
      console.error('Failed to get storage item:', error);
      return null;
    }
  }

  removeItem(key: string): void {
    try {
      this.storage.removeItem(key);
    } catch (error) {
      console.error('Failed to remove storage item:', error);
    }
  }

  clear(): void {
    try {
      this.storage.clear();
    } catch (error) {
      console.error('Failed to clear storage:', error);
    }
  }

  clearSession(): void {
    this.removeItem(STORAGE_KEYS.CUSTOMER_ID);
    this.removeItem(STORAGE_KEYS.SESSION_ID);
  }
}

// Create instances
export const secureStorage = new SecureStorage(true); // Use sessionStorage for security
